<p>connectiontype works!</p>
gfvsc 